<template>
    <div v-if="loader" style="height: 250px; line-height: 250px;">
        <v-progress-circular indeterminate :size="50"></v-progress-circular>
    </div>
    <div v-else class="row ma-4" style="width: 70%;">

        <div class="col-6 justify-content-start">
            <div class="row">
                <v-card-title class="text-left ma-0">{{ $t('suppliers.invoicingTab.contactPhone') }}<span class="red">*</span>
                </v-card-title>
            </div>
            <div class="row">
                <v-text-field v-model="InvoicingPhone" id="InvoicingPhone" name="InvoicingPhone" hide-details
                    persistent-placeholder :placeholder="$t('suppliers.invoicingTab.placeholder.contactPhone')"
                    maxlength="15" @update:model-value="InvoicingPhone = InvoicingPhone.replace(/[^0-9.]/g, '');"
                    variant="outlined" :readonly="!canEdit" :class="!canEdit ? 'readonly-field' : ''"></v-text-field>
                <span class='warningHint' id="WarningMsgDefaultPhone"> {{ msg.InvoicingPhone }}</span>
            </div>
        </div>



        <div class="col-6 justify-content-start">
            <div class="row">
                <v-card-title class="text-left ma-0">{{ $t('suppliers.invoicingTab.invoicingMail') }}<span class="red">*</span></v-card-title>
            </div>
            <div class="row">
                <v-text-field maxlength="40" v-model="invoicingMail"
                    :placeholder="$t('placeholder.enter', { itm: $t('suppliers.placeholder.invoicingMail') })" variant="outlined"
                    hide-details persistent-placeholder name="invoicingMail" id="invoicingMail" :readonly="!canEdit" :class="!canEdit ? 'readonly-field' : ''"></v-text-field>
                <span class='warningHint' id="WarningMsginvoicingMail"> {{ msg.invoicingMail }}</span>
            </div>
        </div>

        <div class="col-6 justify-content-start">
            <div class="row">
                <v-card-title class="text-left ma-0">{{ $t('suppliers.invoicingTab.delivery') }}<span class="red">*</span>
                </v-card-title>
            </div>
            <div class="row">
                <v-autocomplete v-model="Delivery" :items="DeliveryItems" :suffix="'Days'"
                    :placeholder="$t('suppliers.invoicingTab.placeholder.delivery')" variant="outlined"
                    v-model:search="manualDeliveryEstimatedTime" hide-no-data hide-details
                    @update:search="manualDeliveryEstimatedTime = manualDeliveryEstimatedTime.replace(/[^0-9.]/g, '')" :readonly="!canEdit" :class="!canEdit ? 'readonly-field' : ''"
                    >
                </v-autocomplete>
                <span class='warningHint' id="WarningMsgPaymentCondition"> {{ msg.Delivery }}</span>
            </div>
        </div>


        <div class="col-6 justify-content-start">
            <div class="row">
                <v-card-title class="text-left ma-0">{{ $t('suppliers.generalInformation.total') }}<span class="red">*</span>
                </v-card-title>
            </div>
            <div class="row">
                <v-text-field v-model="TotalMinimumOrder" id="TotalMinimumOrder" name="TotalMinimumOrder" hide-details
                    maxlength="9" persistent-placeholder :placeholder="$t('suppliers.generalInformation.placeholder.total')"
                    variant="outlined" :readonly="!canEdit" :class="!canEdit ? 'readonly-field' : ''"></v-text-field>
                <span class='warningHint' id="WarningMsgTotalMinimumOrder"> {{ msg.TotalMinimumOrder }}</span>
            </div>
        </div>






        <div class="col-6 justify-content-start">
            <div class="row">
                <v-card-title class="text-left ma-0">{{ $t('suppliers.generalInformation.payment') }}<span class="red">*</span>
                </v-card-title>
            </div>
            <div class="row">
                <v-autocomplete v-model="PaymentCondition" :items="PaymentConditionItems" :suffix="'Days'"
                    :placeholder="$t('suppliers.generalInformation.placeholder.payment')" variant="outlined"
                    v-model:search="manualPaymentCondition" hide-no-data hide-details
                    @update:search="manualPaymentCondition = manualPaymentCondition.replace(/[^0-9.]/g, '')"
                    :readonly="!canEdit" :class="!canEdit ? 'readonly-field' : ''">
                </v-autocomplete>
                <span class='warningHint' id="WarningMsgPaymentCondition"> {{ msg.PaymentCondition }}</span>
            </div>
        </div>
        <div class="col-6 justify-content-start">
            <div class="row">
                <v-card-title class="text-left ma-0">{{ $t('suppliers.generalInformation.currencies') }}<span class="red">*</span>
                </v-card-title>
            </div>
            <div class="row">
                <v-autocomplete id="Currencies" name="Currencies" v-model="Currencies" :items="CurrenciesItems"
                    item-title="name" item-value="symbol" hide-details persistent-placeholder
                    :placeholder="$t('suppliers.generalInformation.placeholder.currencies')" variant="outlined"
                    :readonly="!canEdit" :class="!canEdit ? 'readonly-field' : ''">
                    <template v-slot:item="{ props, item, index }">
                        <v-list-item v-bind="props" variant="text" :id="index" :name="item.name">
                            {{ item.name }}
                        </v-list-item>
                    </template>
                </v-autocomplete>
                <span class='warningHint' id="WarningMsgCurrencies"> {{ msg.Currencies }}</span>
            </div>
        </div>
        
        
    </div>
</template>
<script>
import currenciesjson from "@/data/DevisesList"
import { GetSupplierInvoicing, isSupplier, idSupplier } from "@/api/index"
export default {
    data: () => ({
        Name: "",
        loader: true,
        item: null,
        msg: [],
        Code: "",
        InvoicingPhone : "",
        PaymentCondition: null,
        Delivery: null,
        PaymentConditionItems: ["10", "15", "20", "30"],
        DeliveryItems: ["10", "15", "20", "30"],
        manualPaymentCondition: '',
        manualDeliveryEstimatedTime : '',
        CurrenciesItems: currenciesjson,
        Currencies: null,
        DefaultPhone: "",
        invoicingMail: "",
        TotalMinimumOrder: "",
        PostalCode: "",
        City: "",
        Address: "",
        country: null,
        suppliersData: {},
        idSupplier: null,
        canEdit: null,
    }),
    created() {
        this.idSupplier = isSupplier() ? idSupplier() : this.$route.params.id;
        this.GetSupplierInvoicing(this.idSupplier);
    },
    watch: {
        InvoicingPhone(value) {
            this.InvoicingPhone = value;
            this.suppliersData.InvoicingPhone = this.InvoicingPhone;
            if (this.InvoicingPhone == "")
                delete this.suppliersData.InvoicingPhone
            this.$emit('getDataFromInvoicing', this.suppliersData)
        },
        manualPaymentCondition(value) {
            let findValue = this.PaymentConditionItems.find(v => v == value);
            if (value != '' && findValue == undefined) {
                this.PaymentConditionItems[4] = value;
            } else {
                this.PaymentConditionItems.splice(4)
            }
        },
        manualDeliveryEstimatedTime(value) {
            let findValue = this.DeliveryItems.find(v => v == value);
            if (value != '' && findValue == undefined) {
                this.DeliveryItems[4] = value;
            } else {
                this.DeliveryItems.splice(4)
            }
        },
        PaymentCondition(value) {
            this.PaymentCondition = value;
            this.suppliersData.PaymentCondition = this.PaymentCondition;
            if (this.PaymentCondition == null || this.PaymentCondition == "")
                delete this.suppliersData.PaymentCondition
            this.$emit('getDataFromInvoicing', this.suppliersData)
        },
        Delivery(value) {
            this.Delivery = value;
            this.suppliersData.Delivery = this.Delivery;
            if (this.Delivery == null || this.Delivery == "")
                delete this.suppliersData.Delivery
            this.$emit('getDataFromInvoicing', this.suppliersData)
        },
        Currencies(value) {
            this.Currencies = value;
            this.suppliersData.Currencies = this.Currencies;
            if (this.Currencies == null || this.Currencies == "")
                delete this.suppliersData.Currencies
            this.$emit('getDataFromInvoicing', this.suppliersData)
        },
        invoicingMail(value) {
            this.invoicingMail = value;
            this.suppliersData.invoicingMail = this.invoicingMail;
            if (this.invoicingMail == "")
                delete this.suppliersData.invoicingMail
            // eslint-disable-next-line
            if ((/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.invoicingMail)) == false)
                delete this.suppliersData.invoicingMail
            this.$emit('getDataFromInvoicing', this.suppliersData)
        },
        TotalMinimumOrder(value) {
            this.TotalMinimumOrder = value;
            this.suppliersData.TotalMinimumOrder = this.TotalMinimumOrder;
            if (this.TotalMinimumOrder == "")
                delete this.suppliersData.TotalMinimumOrder
            this.$emit('getDataFromInvoicing', this.suppliersData)
        }
        
    },
    methods: {
        getCountryFromSelect(value) {
            this.country = value;
        },
        GetSupplierInvoicing: function (idSupplier) {
            GetSupplierInvoicing(idSupplier)
                .then(response => {
                    this.item = response.data;
                   // this.suppliersData.idSupplier = this.item.idSupplier,
                    //this.suppliersData.canEdit = this.item.canEdit;
                    this.canEdit = this.item.canEdit;
                    //this.Name = this.item.name;
                    //this.Code = this.item.code;
                    this.InvoicingPhone = this.item.contactPhone;
                    this.PaymentCondition = this.item.paymentCondition;
                    this.Currencies = this.item.currencies;
                   // this.City = this.item.city;
                   // this.DefaultPhone = this.item.defaultPhone;
                    this.invoicingMail = this.item.invoicingMail;
                    this.Delivery = this.item.delivery;
                    this.TotalMinimumOrder = this.item.totalMinimumOrder;
                    //this.PostalCode = this.item.postalCode;
                    //this.Address = this.item.address;
                    //this.country = this.item.country;
                    //this.suppliersData.status = this.item.status;
                    this.suppliersData.InvoicingPhone = this.InvoicingPhone
                    this.suppliersData.PaymentCondition = this.PaymentCondition 
                    this.suppliersData.Currencies = this.Currencies
                    this.suppliersData.InvoicingMail = this.invoicingMail
                    this.suppliersData.Delivery = this.Delivery
                    this.suppliersData.TotalMinimumOrder = this.TotalMinimumOrder
                    this.loader = false;
                    this.$emit('getDataFromInvoicing', this.suppliersData)
                })
        },
        ControleSaisir() {
            if (this.PaymentCondition == null) {
                this.msg['PaymentCondition'] = this.$t('suppliers.generalInformation.errors.payment');
            } else {
                this.msg['PaymentCondition'] = "";
            }
            if (this.Currencies == null) {
                this.msg['Currencies'] = this.$t('suppliers.generalInformation.errors.currencyks');
            } else {
                this.msg['Currencies'] = "";
            }
            if (!(this.InvoicingPhone) || (this.InvoicingPhone).length == 0) {
                this.msg['InvoicingPhone'] = this.$t('suppliers.generalInformation.errors.defaultPhone');
            } else if (((this.InvoicingPhone).length < 8) || ((this.InvoicingPhone).length > 15)) {
                this.msg['InvoicingPhone'] = this.$t('suppliers.generalInformation.errors.wrongNumber');
            } // eslint-disable-next-line
            else if (this.InvoicingPhone.match(/^[\+]?[0-9]{8,15}$/im)) {
                this.msg['InvoicingPhone'] = '';
            } else {
                this.msg['InvoicingPhone'] = this.$t('suppliers.generalInformation.errors.wrongNumber');
            }
            if (this.invoicingMail == "") {
                this.msg['invoicingMail'] = this.$t('suppliers.generalInformation.errors.invoicingMail');
            }
            // eslint-disable-next-line
            else if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.invoicingMail)) {
                this.msg['invoicingMail'] = "";
            } else {
                this.msg['invoicingMail'] = this.$t('suppliers.generalInformation.errors.wrongEmail');
            }
            if (this.Delivery == "") {
                this.msg['Delivery'] = this.$t('suppliers.generalInformation.errors.delivery');
            } else {
                this.msg['Delivery'] = "";
            }
            if (this.TotalMinimumOrder == "") {
                this.msg['TotalMinimumOrder'] = this.$t('suppliers.generalInformation.errors.total');
            } else {
                this.msg['TotalMinimumOrder'] = "";
            }
            if (
                this.msg['PaymentCondition'] == "" &&
                this.msg['Currencies'] == "" &&
                this.msg['InvoicingPhone'] == "" &&
                this.msg['invoicingMail'] == "" &&
                this.msg['Delivery'] == "" &&
                this.msg['TotalMinimumOrder'] == "" 
            ) {
                return true
            } else {
                return false
            }
        },
    }
}
</script>
<style scoped>
.v-card-title {
    font-family: inter;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    color: #5b6d8e;
    margin-left: 12px;
    margin-bottom: 5px;
}
</style>